import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import history from "../../../../../global/history";
import { keepState } from "../../../../../components/UiComponents/Buttons/BackButton/helper";
import { dateFormatter, dateTimeFormatter } from "../../../../../global";
import classNames from "classnames";
import TableIconButton from "../../../../../components/UiComponents/Buttons/TableIconButton";
import {
  faCheckCircle,
  faPencil as EditIcon,
} from "@fortawesome/free-solid-svg-icons";
import Card from "../../../../../components/Cards/Basic";
import React, { useEffect, useState } from "react";
import useModal from "../../../../../components/Modal/hooks/useModal";
import BookingCheckinDialog from "./BookingCheckinDialog";
import {
  showSuccessToast,
  showValidationErrorToast,
} from "../../../../../components/Toasts";
import { navigateTo } from "../../../../../global/navigationHelper";
import axios from "../../../../../config/axios";
import GuestPassDialog from "../GuestPassDialog";
import CheckoutGuestDialog from "./CheckoutGuestDialog";
import ConfirmDeleteDialog from "../../../../../components/Modal/ConfirmDelete";
import EllipsisDropdown, {
  EllipsisDropdownItem,
  EllipsisDropdownSection,
} from "../../../../../components/EllipsisDropdown";
import CompleteStayInitialCheckinDialog from "src/pages/Dashboard/Bookings/StayDetailsPage/GuestSection/CompleteStayInitialCheckinDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const GuestSection = ({ stay, getStay }) => {
  const [generalSettings, setGeneralSettings] = useState();

  useEffect(() => {
    axios.get("/api/v1/booking_settings/show_general.json").then((response) => {
      setGeneralSettings(response.data.settings);
    });
  }, []);

  const { isShow: showCheckinDialog, toggle: toggleCheckinDialog } = useModal();
  const { isShow: showGuestPassesDialog, toggle: toggleGuestPassesDialog } =
    useModal();
  const {
    isShow: showStayInitialCheckinDialog,
    toggle: toggleStayInitialCheckinDialog,
  } = useModal();
  const [selectedCheckoutGuest, setSelectedCheckoutGuest] = useState(false);
  const [selectedDeleteGuest, setSelectedDeleteGuest] = useState();

  let guests = stay?.guests || [];

  function handleCheckinSuccess() {
    getBooking();
    toggleCheckinDialog();
    showSuccessToast();
  }

  function handleCheckoutSuccess() {
    getStay();
    setSelectedCheckoutGuest(null);
    showSuccessToast();
  }

  function deleteGuest() {
    axios.delete(`/api/v1/guests/${selectedDeleteGuest.id}.json`).then(
      () => {
        getStay();
        setSelectedDeleteGuest(null);
      },
      function (error) {
        showValidationErrorToast(error);
      }
    );
  }

  function handleInitialCheckinSuccess() {
    getStay();
    toggleStayInitialCheckinDialog();
  }

  function handleAddGuest() {
    history.push(`/dashboard/stays/${stay.id}/guests/new`, keepState(history));
  }

  function handleEditGuest(guest) {
    navigateTo(`/dashboard/stays/${stay.id}/guests/${guest.id}/edit`);
  }

  return (
    <Card
      title={"Gäste"}
      footer={
        <>
          {!stay.checkout_confirmed_at && (
            <Button variant="primary" onClick={handleAddGuest} className="mr-2">
              Gast hinzufügen
            </Button>
          )}
          {!stay.initial_checkin_at && (
            <Button
              variant="secondary"
              onClick={toggleStayInitialCheckinDialog}
              className="mr-2"
            >
              Check-In abschließen
            </Button>
          )}

          {generalSettings?.guest_pass?.enabled && stay.initial_checkin_at && (
            <Button
              variant={"secondary"}
              onClick={() => toggleGuestPassesDialog()}
            >
              Guest pass anzeigen
            </Button>
          )}
        </>
      }
    >
      <div className="ui-table-container">
        <table cellSpacing="0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Land</th>
              <th>Geburtstag</th>
              <th>CheckIn</th>
              <th>CheckOut</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {guests &&
              guests.map((guest) => (
                <tr key={guest.id}>
                  <td>{guest.full_name}</td>
                  <td>{guest.citizenship.name}</td>
                  <td>
                    {dateFormatter(guest.birth_date)} ({guest.age} J.)
                  </td>
                  <td>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>
                          {guest?.lts_checkin_report?.status === "completed"
                            ? "Meldung abgeschlossen"
                            : guest?.lts_checkin_report?.status === "failed"
                            ? "Meldung fehlerhaft"
                            : guest?.lts_checkin_report?.status === "outdated"
                            ? "Meldung veraltet"
                            : "Meldung ausstehend"}
                        </Tooltip>
                      }
                    >
                      <span
                        className={classNames({
                          "text-success":
                            guest.lts_checkin_report?.status === "completed",
                          "text-danger":
                            guest.lts_checkin_report?.status === "failed",
                          "text-warning":
                            guest.lts_checkin_report?.status !== "failed" &&
                            guest.lts_checkin_report?.status !== "completed",
                        })}
                      >
                        {dateTimeFormatter(guest.checkin_at)}
                      </span>
                    </OverlayTrigger>
                  </td>
                  <td>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>
                          {guest?.lts_checkout_report?.status === "completed"
                            ? "Meldung abgeschlossen"
                            : guest?.lts_checkout_report?.status === "failed"
                            ? "Meldung fehlerhaft"
                            : guest?.lts_checkout_report?.status === "outdated"
                            ? "Meldung veraltet"
                            : "Meldung ausstehend"}
                        </Tooltip>
                      }
                    >
                      <span
                        className={classNames({
                          "text-success":
                            guest.lts_checkout_report?.status === "completed",
                          "text-danger":
                            guest.lts_checkout_report?.status === "failed",
                          "text-warning":
                            guest.lts_checkout_report?.status !== "failed" &&
                            guest.lts_checkout_report?.status !== "completed",
                        })}
                      >
                        {dateTimeFormatter(guest.checkout_at)}
                        {guest.checkout_confirmed_at && (
                          <span className="ml-2">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-success"
                            ></FontAwesomeIcon>
                          </span>
                        )}
                      </span>
                    </OverlayTrigger>
                  </td>
                  <td>
                    <div className={"d-flex align-items-center"}>
                      <TableIconButton
                        icon={EditIcon}
                        variant={"primary"}
                        onClick={() => handleEditGuest(guest)}
                      />
                      <EllipsisDropdown className={"m-2"}>
                        <EllipsisDropdownSection>
                          {guest?.guest_pass?.card.status === "active" && (
                            <EllipsisDropdownItem
                              onClick={() =>
                                window.open(
                                  guest?.guest_pass?.card.pdf_url,
                                  "_blank"
                                )
                              }
                            >
                              Guest Pass öffnen
                            </EllipsisDropdownItem>
                          )}
                        </EllipsisDropdownSection>
                        <EllipsisDropdownSection>
                          <EllipsisDropdownItem
                            onClick={() => {
                              setSelectedDeleteGuest(guest);
                            }}
                          >
                            Löschen
                          </EllipsisDropdownItem>
                        </EllipsisDropdownSection>
                      </EllipsisDropdown>
                    </div>
                  </td>
                </tr>
              ))}

            {guests.length === 0 && (
              <tr>
                <td colSpan={6}>Keine Gäste vorhanden</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showCheckinDialog && (
        <BookingCheckinDialog
          booking={booking}
          handleSubmit={handleCheckinSuccess}
          handleClose={() => {
            toggleCheckinDialog();
          }}
        ></BookingCheckinDialog>
      )}

      {selectedCheckoutGuest && (
        <CheckoutGuestDialog
          guest={selectedCheckoutGuest}
          handleSubmit={handleCheckoutSuccess}
          handleClose={() => {
            setSelectedCheckoutGuest(null);
          }}
        ></CheckoutGuestDialog>
      )}

      {showGuestPassesDialog && (
        <GuestPassDialog
          stay={stay}
          handleClose={toggleGuestPassesDialog}
        ></GuestPassDialog>
      )}

      {selectedDeleteGuest && (
        <ConfirmDeleteDialog
          show={true}
          handleDelete={deleteGuest}
          handleClose={() => {
            setSelectedDeleteGuest(null);
          }}
        ></ConfirmDeleteDialog>
      )}

      {showStayInitialCheckinDialog && (
        <CompleteStayInitialCheckinDialog
          stay={stay}
          handleClose={toggleStayInitialCheckinDialog}
          handleSubmit={handleInitialCheckinSuccess}
        />
      )}
    </Card>
  );
};

export default GuestSection;
